export const gqlSubscribeFilteredPartnerLocation = /* GraphQL */ `
  subscription SubscribeFilteredPartnerLocation(
    $filter: String
  ) {
    subscribeFilteredPartnerLocation(
      filter: $filter
    ) {
      resource_name
      timestamp
      position {
        latitude
        longitude
        altitude
        accuracy
        altitude_accuracy
        heading
        speed
      }
    }
  }
`;
